export default (value: string | null) => {
  const postcodeRegEx = /^[A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}$/gi

  if (value && !value.match(postcodeRegEx)) {
    return "Postcode is not valid format"
  }

  return true
}
